import React, { Component } from 'react'

class CheckboxesField extends Component {
    constructor() {
        super()
        this.pictures = []
        this.onClick = this.onClick.bind(this)
        this.all = this.all.bind(this)
    }

    onClick(value) {
        const { input } = this.props
        let inputValue = input.value
        //if (inputValue && typeof(inputValue) !== 'Array') inputValue = [inputValue]
        const indexOfValue = inputValue.indexOf(value)
        if (!inputValue || inputValue[0] === undefined) {
            if (this.props.onChange) this.props.onChange([value])
            return input.onChange(input.value = [value])
        }
        if (indexOfValue === -1) inputValue.push(value)
        else inputValue.splice(indexOfValue, 1)
        if (this.props.onChange) this.props.onChange(inputValue)
        return input.onChange(input.value = inputValue)
    }

    all(checked = true) {
        const { refs } = this
        for (let i in refs) {
            refs[i].checked = checked
        }
        if (checked)
            return this.props.input.onChange(this.props.fields.map((field) => field.value))
        return this.props.input.onChange([])
    }

    render() {
        const { label, name, input, fields, initialValues, values, meta: { error, touched }, className = 'checkbox-inline', selectAll, live } = this.props 
        
        return (
            <div className='row'>
                <div className='col-md-12'>
                    {
                        label ?
                            <h5>
                                { label }
                                {
                                    selectAll ?
                                        <span className='pull-right'>
                                            <a className='btn btn-xs btn-primary m-r-8' onClick={ this.all.bind(this, false) } style={{ marginRight: 8 }}>
                                                Aucun
                                            </a>
                                            <a className='btn btn-xs btn-primary' onClick={ this.all }>
                                                Tous
                                            </a>
                                        </span>
                                    : null
                                }
                            </h5>
                        : null
                    }
                    {
                        fields.map((field, index) => 
                            <div className={ `${className} checkbox-inline` } key={ `checkbox-${name}-${index}` }>
                                <label>
                                    <input
                                        type='checkbox'
                                        ref={ `checkbox-${index}` }
                                        checked={ !live ? undefined : values && values.indexOf(field.value) !== -1 }
                                        name={ name }
                                        value={ field.value }
                                        onClick={ this.onClick.bind(this, field.value) }
                                        defaultChecked={ live ? undefined : initialValues && initialValues.indexOf(field.value) !== -1 }
                                    />
                                    { field.label }
                                </label>
                            </div>
                        )
                    }
                    { touched && ((error && <p className='error'>{error}</p>)) }
                </div>
            </div>
        )
    }
}

export default CheckboxesField


// WEBPACK FOOTER //
// ./src/client/features/form/components/CheckboxesField.jsx